module.exports = __webpack_public_path__ + "static/media/img5.153e27ba.svg";